import React, { Component } from "react";
import { RESTExecutor, withDomains } from "../../lib/domain";
import { Link } from "react-router-dom";
import {
  Spin,
  Divider,
  Table,
  Row,
  Tag,
  Badge,
  Descriptions,
  Select,
  Popconfirm,
  Button,
  Modal,
  Affix,
  Checkbox,
  Input,
  InputNumber,
} from "antd";
import moment from "moment";
import {
  formatMoney,
  showErrorInNotification,
  defaultDateFormat,
  overrideHeaderBack,
} from "../../lib/util";
import Title from "antd/lib/typography/Title";
import ErrorWrapper from "../../lib/error_wrapper";
import Text from "antd/lib/typography/Text";

import Highlighter from "react-highlight-words";
import CustomDateRangePicker from "../../components/custom_date_range";
import ModalTransactionDetail from "../../components/modal_transaction_detail";
import FilterFixedInput from "../../components/filter_fixed_input";
import { BasicHeader } from "../../components/basic_header";
import { CustomStatsSmall } from "../../components/custom_stat";
import { OUR_COLOR, THEIR_COLOR, COLORS } from "../theme.js";
import { CustomButton, TransparentButton } from "../../components/basic_items";
import lodash from "lodash";
import PendingReconciledItem from "../../components/pending_reconciled_items";
import { StorageOutlined } from "@material-ui/icons";

const queryString = require("query-string");

export const period_selection = [
  {
    text: "Last 7 days",
    value: 7,
  },
  {
    text: "Last 30 days",
    value: 30,
  },
  {
    text: "Last 60 days",
    value: 60,
  },
];

class ManualReconciled extends Component {
  constructor(props) {
    super(props);

    this.reconciler_id = props.match.params.reconciler_id;
    this.source_id = props.match.params.source_id;
    this.group_id = props.match.params.group_id;

    this.state = {
      loading: true,
      table_cols: [],
      our_table_cols: [],
      their_table_cols: [],
      selected_data: [],
      expandedKeys: [],
      // our_source_options: [],
      filter_query: {
        per_page: 100,
        page: 1,
        dateFrom: moment().subtract(6, "days").format(defaultDateFormat),
        dateTo: moment().format(defaultDateFormat),
        source_id: props.match.params.source_id,
      },
      our_services: [],
      their_services: [],
    };

    this.list_reconciled_data = RESTExecutor.list()
      .config({
        label: "manual_reconciled",
        params: {
          ...this.getParams(),
        },
      })
      .callbacks(
        (success) => {
          this.setState({ loading: false });
        },
        (error) => {
          this.setState({
            loading: false,
          });
        }
      )
      .forId(this.reconciler_id)
      .connect(props.domains.reconciliation);

    this.get_recon_process = RESTExecutor.detail()
      .config({
        label: "detail_reconcilers",
      })
      .forId(this.reconciler_id)
      .callbacks(
        (success) => {
          const result = success.result ?? {};
          const reference = result.__references__ ?? {};
          const ourDatatype = reference.our_data_type_id ?? {};
          const theirDatatype = reference.their_data_type_id ?? {};
          this.getServicesForDatatype(theirDatatype.id, "their_services");
          this.getServicesForDatatype(ourDatatype.id, "our_services");

          this.setState({ loading: false });
          // this.changeTableCols(success)
          // this.list_sources.forId(success.result.our_data_type_id).execute();
          this.list_reconciled_data
            .forId(this.reconciler_id)
            .config({
              params: {
                ...this.state.filter_query,
              },
            })
            .execute();
        },
        (error) => {
          this.setState({ loading: false });
          showErrorInNotification(error);
          console.log("error in getting ", error);
        }
      )
      .connect(props.domains.reconciliation);

    this.reject_manually = RESTExecutor.post()
      .config({
        label: "reject_manually",
      })
      .callbacks(
        (success) => {
          this.setState(
            {
              selected_data: [],
            },
            () => {
              this.list_reconciled_data.execute();
            }
          );
        },
        (error) => {
          showErrorInNotification(error);
        }
      )
      .connect(props.domains.reconciliation);

    this.list_services_fordatatype = RESTExecutor.list()
      .config({
        label: "datatype_services",
        params: {
          pagination: false,
        },
      })
      .callbacks(
        () => {
          console.log("listed for manual");
        },
        (error) => {
          showErrorInNotification(error);
        }
      )
      .connect(props.domains.allData);

    // this.get_recon_process.execute();
    // this.list_sources.execute();

    // this.list_reconciled_data.execute();
  }

  getParams = () => {
    let params = JSON.parse(JSON.stringify(this.state.filter_query));

    return params;
  };

  getServicesForDatatype = (datatypeID, stateKey) => {
    this.list_services_fordatatype
      .forId(datatypeID)
      .callbacks((success) => {
        let results = success.result ?? {};
        this.setState({
          [stateKey]: results.rows ?? [],
        });
      })
      .execute();
  };

  stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
    let newData = this.state[stateKey];
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj);
    }
    console.log(newData);
    this.setState(
      {
        [stateKey]: newData,
      },
      () => {
        typeof callback === "function" && callback();
      }
    );
  };

  onSelect = (id, data) => {
    this.setState((prevState) => ({
      selected_data: this.state.selected_data.includes(id)
        ? prevState.selected_data.filter((x) => x !== id)
        : [...prevState.selected_data, id],
    }));
  };

  render() {
    const { loading, selected_data, expandedKeys, filter_query } = this.state;
    if (loading) {
      return (
        <center>
          <Spin />
        </center>
      );
    }

    let list_reconciled_data_resp = this.list_reconciled_data.response();
    let list_reconciled_data_data = list_reconciled_data_resp.result || {};
    let get_recon_process_resp = this.get_recon_process.response();
    let get_recon_process_data = get_recon_process_resp.result || {};
    let reference = get_recon_process_data.__references__ || {};

    let reject_manually_resp = this.reject_manually.response();

    let our_datatype = reference.our_data_type_id || {};
    let their_datatype = reference.their_data_type_id || {};
    let rowData = list_reconciled_data_data.rows || [];
    let rowMeta = list_reconciled_data_resp.meta || {};

    return (
      <ErrorWrapper
        error={get_recon_process_resp}
        onReload={() => {
          this.setState({ loading: true });
          this.get_recon_process.forId(this.reconciler_id).execute();
        }}
      >
        <BasicHeader
          title={get_recon_process_data.name}
          titleType="Reconciler"
          subtitle="Reconciled"
          right={[
            <Link
              to={`/recon/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${this.reconciler_id}/pending`}
            >
              <TransparentButton
                label="Pending"
                icon={<StorageOutlined />}
                hint="View Pending"
              />
            </Link>,
            <Link
              to={`/recon/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${this.reconciler_id}/unreconciled`}
            >
              <TransparentButton
                label="Unreconciled"
                icon={<StorageOutlined />}
                hint="View Unreconciled"
              />
            </Link>,
          ]}
        />

        <div className="filter-card">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              paddingTop: 4,
              paddingBottom: 4,
            }}
          >
            <FilterFixedInput label="Type">
              <Select
                placeholder="Type"
                allowClear
                value={filter_query.type}
                className={
                  filter_query.type != null ? "filter-option-selected" : ""
                }
                filterOption={false}
                onChange={(value) => {
                  this.stateUpdater({
                    stateKey: "filter_query",
                    valueKey: "type",
                    value: value,
                    callback: () => {
                      this.props.history.push({
                        search: queryString.stringify({
                          ...this.state.filter_query,
                          page: 1,
                        }),
                      });
                    },
                  });
                }}
              >
                <Select.Option key={"true"} value={"true"}>
                  Manual
                </Select.Option>
                <Select.Option key={"false"} value={"false"}>
                  Automatic
                </Select.Option>
              </Select>
            </FilterFixedInput>
            <FilterFixedInput label="Date Range">
              <CustomDateRangePicker
                excludeRanges
                // dateLimit={{
                //   days: 7,
                // }}
                startDate={
                  filter_query.dateFrom
                    ? moment(filter_query.dateFrom, defaultDateFormat)
                    : null
                }
                endDate={
                  filter_query.dateTo
                    ? moment(filter_query.dateTo, defaultDateFormat)
                    : null
                }
                onChange={(dates) => {
                  //   console.log("GOT DATES",dates.startDate.toISOString(),dates.endDate.toISOString())
                  this.stateUpdater({
                    stateKey: "filter_query",
                    appendObj: {
                      dateFrom: dates.startDate.format(defaultDateFormat),
                      dateTo: dates.endDate.format(defaultDateFormat),
                    },
                    callback: () => {
                      this.props.history.push({
                        search: queryString.stringify({
                          ...this.state.filter_query,
                          page: 1,
                        }),
                      });
                    },
                  });
                }}
              />
            </FilterFixedInput>
          </div>
          <Button
            onClick={() =>
              this.setState({
                advanceFilter: !this.state.advanceFilter,
              })
            }
          >
            Show Advanced Filters
          </Button>
          {this.state.advanceFilter && (
            <div style={{ display: "flex", gap: "16px" }}>
              <div style={{ width: "50%", textAlign: "start" }}>
                <div>
                  <div style={{ marginTop: "30px" }}>OURS </div>
                  <div
                    className="flex-container"
                    //   style={{
                    //     display: "flex",
                    //     flexDirection: "row",
                    //     flexWrap: "wrap",
                    //     paddingTop: 20,
                    //   }}
                  >
                    <div className="flex-items">
                      <Input.Search
                        placeholder="Search Query"
                        className="flex-items"
                        //   style={{
                        //     marginTop: 0,
                        //     marginBottom: 10,
                        //     marginRight: 10,
                        //     width: "100%",
                        //   }}
                        value={filter_query.our_query}
                        onChange={(e) => {
                          this.stateUpdater({
                            stateKey: "filter_query",
                            valueKey: "our_query",
                            value: e.target.value,
                          });
                        }}
                      />
                    </div>
                    <CustomDateRangePicker
                      style={{
                        width: "49%",
                        flex: null,
                      }}
                      excludeRanges
                      // dateLimit={{
                      //   days: 7,
                      // }}
                      startDate={
                        filter_query.our_date_from
                          ? moment(
                              filter_query.our_date_from,
                              defaultDateFormat
                            )
                          : null
                      }
                      endDate={
                        filter_query.our_date_to
                          ? moment(filter_query.our_date_to, defaultDateFormat)
                          : null
                      }
                      onChange={(dates) => {
                        //   console.log("GOT DATES",dates.startDate.toISOString(),dates.endDate.toISOString())
                        this.stateUpdater({
                          stateKey: "filter_query",
                          appendObj: {
                            our_date_from:
                              dates.startDate.format(defaultDateFormat),
                            our_date_to:
                              dates.endDate.format(defaultDateFormat),
                            page: 1,
                          },
                          callback: () => {
                            //   console.log("limlasdf");
                            // this.props.history.push({
                            //   search: queryString.stringify(this.state.filter_query)
                            // })
                            // this.list_transaction.config({
                            //     params: {
                            //         ...this.getParams(),
                            //         per_page:20,
                            //         page:1
                            //     }
                            // }).execute()
                          },
                        });
                      }}
                    />

                    <Select
                      allowClear
                      showSearch
                      className={
                        filter_query.our_service_id
                          ? "filter-option-selected"
                          : ""
                      }
                      style={{
                        width: "49%",
                      }}
                      placeholder="Select Service"
                      value={filter_query.our_service_id}
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      onChange={(value, e) => {
                        this.stateUpdater({
                          stateKey: "filter_query",
                          valueKey: "our_service_id",
                          value: value,
                        });
                      }}
                    >
                      {this.state.our_services.map((item, index) => {
                        let source = item;

                        return (
                          <Select.Option
                            title={source.name}
                            value={item.id}
                            key={item.id}
                          >
                            {source.name}
                          </Select.Option>
                        );
                      })}
                    </Select>
                    <Select
                      allowClear
                      showSearch
                      className={
                        filter_query.our_type ? "filter-option-selected" : ""
                      }
                      style={{
                        //   marginTop: 0,
                        //   marginBottom: 10,
                        //   marginRight: 10,
                        width: "49%",
                      }}
                      placeholder="Transaction Type"
                      value={filter_query.our_type}
                      // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                      onChange={(value, e) => {
                        this.stateUpdater({
                          stateKey: "filter_query",
                          valueKey: "our_type",
                          value: value,
                        });
                      }}
                    >
                      <Select.Option value={"D"} key={"D"}>
                        Debit
                      </Select.Option>
                      <Select.Option value={"C"} key={"C"}>
                        Credit
                      </Select.Option>
                      <Select.Option value={"N/A"} key={"N/A"}>
                        N/A
                      </Select.Option>
                    </Select>
                    <InputNumber
                      placeholder="Amount"
                      style={{
                        //   marginTop: 0,
                        //   marginBottom: 10,
                        //   marginRight: 10,
                        width: "49%",
                      }}
                      value={filter_query.our_amount}
                      onChange={(value) => {
                        this.stateUpdater({
                          stateKey: "filter_query",
                          valueKey: "our_amount",
                          value: value,
                        });
                      }}
                    />
                    <InputNumber
                      placeholder="Offset"
                      disabled={!filter_query.our_amount}
                      style={{
                        //   marginTop: 0,
                        //   marginBottom: 10,
                        //   marginRight: 10,
                        width: "49%",
                      }}
                      value={filter_query.our_offset}
                      onChange={(value) => {
                        this.stateUpdater({
                          stateKey: "filter_query",
                          valueKey: "our_offset",
                          value: value,
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
              <div style={{ width: "50%", textAlign: "start" }}>
                <div style={{ marginTop: "30px" }}>THIERS</div>
                <div
                  className="flex-container"
                  // style={{
                  //   display: "flex",
                  //   flexDirection: "row",
                  //   flexWrap: "wrap",
                  //   paddingTop: 20,
                  //   justifyContent: "end",
                  // }}
                >
                  <Input.Search
                    placeholder="Search Query"
                    style={{
                      // marginTop: 0,
                      // marginBottom: 10,
                      // marginRight: 10,
                      width: "49%",
                    }}
                    value={filter_query.their_query}
                    onChange={(e) => {
                      this.stateUpdater({
                        stateKey: "filter_query",
                        valueKey: "their_query",
                        value: e.target.value,
                      });
                    }}
                  />
                  <CustomDateRangePicker
                    style={{
                      width: "49%",
                      // marginRight: 10,
                      flex: null,
                    }}
                    excludeRanges
                    // dateLimit={{
                    //   days: 7,
                    // }}
                    startDate={
                      filter_query.their_date_from
                        ? moment(
                            filter_query.their_date_from,
                            defaultDateFormat
                          )
                        : null
                    }
                    endDate={
                      filter_query.their_date_to
                        ? moment(filter_query.their_date_to, defaultDateFormat)
                        : null
                    }
                    onChange={(dates) => {
                      //   console.log("GOT DATES",dates.startDate.toISOString(),dates.endDate.toISOString())
                      this.stateUpdater({
                        stateKey: "filter_query",
                        appendObj: {
                          their_date_from:
                            dates.startDate.format(defaultDateFormat),
                          their_date_to:
                            dates.endDate.format(defaultDateFormat),
                          page: 1,
                        },
                        callback: () => {
                          //   console.log("limlasdf");
                          // this.props.history.push({
                          //   search: queryString.stringify(this.state.filter_query)
                          // })
                          // this.list_transaction.config({
                          //     params: {
                          //         ...this.getParams(),
                          //         per_page:20,
                          //         page:1
                          //     }
                          // }).execute()
                        },
                      });
                    }}
                  />

                  <Select
                    allowClear
                    showSearch
                    className={
                      filter_query.their_service_id
                        ? "filter-option-selected"
                        : ""
                    }
                    style={{
                      width: "49%",
                    }}
                    placeholder="Select Service"
                    value={filter_query.their_service_id}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={(value, e) => {
                      this.stateUpdater({
                        stateKey: "filter_query",
                        valueKey: "their_service_id",
                        value: value,
                      });
                    }}
                  >
                    {this.state.their_services.map((item, index) => {
                      let source = item;

                      return (
                        <Select.Option
                          title={source.name}
                          value={item.id}
                          key={item.id}
                        >
                          {source.name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                  <Select
                    allowClear
                    showSearch
                    className={
                      filter_query.their_type ? "filter-option-selected" : ""
                    }
                    style={{
                      // marginTop: 0,
                      // marginBottom: 10,
                      // marginRight: 10,
                      width: "49%",
                    }}
                    placeholder="Transaction Type"
                    value={filter_query.their_type}
                    // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    onChange={(value, e) => {
                      this.stateUpdater({
                        stateKey: "filter_query",
                        valueKey: "their_type",
                        value: value,
                      });
                    }}
                  >
                    <Select.Option value={"D"} key={"D"}>
                      Debit
                    </Select.Option>
                    <Select.Option value={"C"} key={"C"}>
                      Credit
                    </Select.Option>
                    <Select.Option value={"N/A"} key={"N/A"}>
                      N/A
                    </Select.Option>
                  </Select>
                  <InputNumber
                    placeholder="Amount"
                    style={{
                      // marginTop: 0,
                      // marginBottom: 10,
                      // marginRight: 10,
                      width: "49%",
                    }}
                    value={filter_query.their_amount}
                    onChange={(value) => {
                      this.stateUpdater({
                        stateKey: "filter_query",
                        valueKey: "their_amount",
                        value: value,
                      });
                    }}
                  />
                  <InputNumber
                    placeholder="Offset"
                    disabled={!filter_query.their_amount}
                    style={{
                      // marginTop: 0,
                      // marginBottom: 10,
                      // marginRight: 10,
                      width: "49%",
                    }}
                    value={filter_query.their_offset}
                    onChange={(value) => {
                      this.stateUpdater({
                        stateKey: "filter_query",
                        valueKey: "their_offset",
                        value: value,
                      });
                    }}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    paddingTop: 8,
                    paddingBottom: 8,
                    justifyContent: "end",
                  }}
                >
                  <CustomButton
                    className="primary-btn"
                    onClick={() => {
                      // this.setState({
                      //   selectedID: null,
                      //   pageLoading: true,
                      //   hasFilter: true,
                      // });
                      //   typeof this.props.onSelectedID === "function" &&
                      //     this.props.onSelectedID(null);

                      this.list_reconciled_data
                        .config({
                          params: {
                            source_id: this.source_id,
                            reconciler_id: this.reconciler_id,
                            ...this.state.filter_query,
                          },
                        })
                        .execute();
                    }}
                    label="FILTER"
                  />

                  <CustomButton
                    className="danger-btn"
                    onClick={() => {
                      this.setState(
                        {
                          filter_query: {
                            source_id: this.source_id,
                            reconciler_id: this.reconciler_id,
                          },
                          pageLoading: true,
                          selectedID: null,
                          hasFilter: false,
                        },
                        () => {
                          // this.setState({ filter_query: {} });
                          //   typeof this.props.onSelectedID ===
                          //     "function" && this.props.onSelectedID(null);
                          this.list_reconciled_data
                            .config({
                              params: {
                                ...this.state.filter_query,
                              },
                            })
                            .execute();
                        }
                      );
                    }}
                    label="CLEAR ALL"
                  />
                </div>
              </div>
            </div>
          )}
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "nowrap",
            backgroundColor: COLORS.main_bg_color,
            top: 56,
          }}
          className="sticky-content"
        >
          <div
            style={{
              width: 40,
              // backgroundColor: 'red',
              margin: 8,
              marginRight: 0,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Checkbox
              disabled={rowMeta.data_count == 0}
              checked={
                selected_data.length == rowMeta.data_count &&
                rowMeta.data_count != 0
              }
              indeterminate={
                selected_data.length > 0 &&
                selected_data.length != rowMeta.data_count
              }
              onChange={(e) => {
                if (selected_data.length > 0) {
                  this.setState({ selected_data: [] });
                } else {
                  this.setState({ selected_data: lodash.map(rowData, "id") });
                }
              }}
            />
          </div>
          <div
            className="filter-card"
            style={{
              flex: 1,
              maxWidth: "calc(100% - 40px)",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "nowrap",
                width: "100%",
              }}
            >
              <div
                title={our_datatype.name}
                style={{
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  textAlign: "left",
                  color: OUR_COLOR,
                  // maxWidth:'20%'
                }}
              >
                {our_datatype.name}
              </div>
              <Row
                type="flex"
                style={{
                  // flex: 1,
                  justifyContent: "center",
                  alignItems: "center",
                  // minWidth:480
                  flexWrap: "nowrap",
                }}
              >
                <Popconfirm
                  title={`Are you sure you want to reject ${selected_data.length} records?`}
                  onConfirm={() => {
                    this.reject_manually.forId(this.reconciler_id).execute({
                      txn_ids: selected_data,
                    });
                  }}
                >
                  <CustomButton
                    className="danger-btn fill-danger-btn"
                    disabled={
                      (selected_data && selected_data.length === 0) ||
                      reject_manually_resp.fetching
                    }
                    onClick={() => {}}
                    label={`Reject ${
                      selected_data.length > 0
                        ? ` ${selected_data.length} Record(s)`
                        : ``
                    }`}
                  />
                </Popconfirm>

                <CustomButton
                  className="danger-btn "
                  disabled={selected_data.length == 0}
                  onClick={() => {
                    this.setState({ selected_data: [] });
                  }}
                  label={`CLEAR ALL`}
                />
              </Row>

              <div
                title={their_datatype.name}
                style={{
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  // maxWidth:'20%',
                  color: THEIR_COLOR,
                }}
              >
                {their_datatype.name}
              </div>
            </div>
          </div>
        </div>

        <ErrorWrapper
          error={list_reconciled_data_resp}
          onReload={() => {
            this.list_reconciled_data.forId(this.reconciler_id).execute();
          }}
        >
          <div>
            <Modal
              visible={this.state.view_transaction_modal}
              width={"90%"}
              destroyOnClose
              footer={null}
              centered
              className="transaction-modal"
              onCancel={() => {
                this.setState({
                  view_transaction_modal: false,
                  view_transaction_id: null,
                });
              }}
            >
              <ModalTransactionDetail
                onClose={() => {
                  this.setState({
                    view_transaction_modal: false,
                    view_transaction_id: null,
                  });
                }}
                isModal={true}
                match={{
                  params: {
                    transaction_id: this.state.view_transaction_id,
                  },
                }}
                transaction_id={this.state.view_transaction_id}
              />
            </Modal>
            <div>
              <div>
                <Table
                  scroll={{ x: true }}
                  size="small"
                  className="noHover no-separator-table single-column"
                  loading={list_reconciled_data_resp.fetching}
                  dataSource={rowData}
                  bordered
                  // rowClassName='no_expanded_row_mobile'
                  key="reconciled_table"
                  rowKey={(record) => `${record.id}`}
                  pagination={{
                    position: "bottom",
                    // showSizeChanger: true,
                    onChange: (current, size) => {
                      console.log(current, size);
                      this.setState({
                        expandedKeys: [],
                      });
                      this.props.history.push({
                        search: queryString.stringify({
                          ...this.state.filter_query,
                          page: current,
                        }),
                      });

                      // this.stateUpdater({
                      //   stateKey: 'filter_query',
                      //   appendObj: {
                      //     per_page: size,
                      //     page: current
                      //   },
                      //   callback: () => {
                      //     console.log("calling")
                      //     this
                      //       .list_reconciled_data
                      //       .config({
                      //         params: {
                      //           ...this.getParams(),
                      //         }
                      //       })
                      //       .execute();
                      //   }
                      // });
                    },
                    defaultCurrent: 1,
                    current:
                      rowMeta.pagination &&
                      parseInt(rowMeta.pagination.split("/")[0]),
                    // defaultPageSize: 20,
                    pageSize: rowMeta && rowMeta.requested_count,

                    total:
                      rowMeta && rowMeta.total_count == 10001
                        ? 10000
                        : rowMeta.total_count,
                    showTotal: (total, range) =>
                      `${formatMoney(range[0], 0)}-${formatMoney(
                        range[1],
                        0
                      )} of ${
                        rowMeta.total_count > 10000
                          ? `10,000+`
                          : formatMoney(rowMeta.total_count, 0)
                      } items`,
                  }}
                  // rowSelection={rowSelection}
                  columns={[
                    {
                      key: "col_key",
                      render: (record) => {
                        return (
                          <PendingReconciledItem
                            data={record}
                            id={record.id}
                            onSelect={this.onSelect}
                            selectedIDS={selected_data}
                            rule={{}}
                            onViewDetailClicked={(id) => {
                              this.setState({
                                view_transaction_id: id,
                                view_transaction_modal: true,
                              });
                            }}
                          />
                        );
                      },
                    },
                  ]}
                />
              </div>
            </div>
          </div>
        </ErrorWrapper>
      </ErrorWrapper>
    );
  }

  componentDidMount() {
    let new_filter_query = {};
    if (this.props.location && this.props.location.search) {
      const parsed = queryString.parse(this.props.location.search);
      new_filter_query = parsed;
    }
    this.setState(
      {
        filter_query: {
          per_page: 100,
          page: 1,
          dateFrom: moment().subtract(6, "days").format(defaultDateFormat),
          dateTo: moment().format(defaultDateFormat),
          ...new_filter_query,
          source_id: this.source_id,
        },
        selected_data: [],
      },
      () => {
        this.get_recon_process.execute();
        // this.list_packets.config({
        //     params: {
        //     ...this.state.filter_query
        //     }
        // }).execute()
      }
    );
  }
  componentWillUnmount() {
    overrideHeaderBack(null);
  }

  componentWillReceiveProps(nextProps) {
    var oldreconciler_id = this.props.match.params.reconciler_id;
    var newreconciler_id = nextProps.match.params.reconciler_id;

    if (
      oldreconciler_id !== newreconciler_id ||
      (this.props.location &&
        this.props.location.search !== nextProps.location.search)
    ) {
      this.reconciler_id = newreconciler_id;
      this.source_id = nextProps.match.params.source_id;
      this.group_id = nextProps.match.params.group_id;
      const parsed = queryString.parse(nextProps.location.search);
      this.setState(
        {
          filter_query: {
            per_page: 100,
            page: 1,
            dateFrom: moment().subtract(6, "days").format(defaultDateFormat),
            dateTo: moment().format(defaultDateFormat),
            ...parsed,
            source_id: nextProps.match.params.source_id,
          },
          selected_data: [],
        },
        () => {
          if (oldreconciler_id !== newreconciler_id) {
            this.setState(
              {
                loading: true,
              },
              () => {
                this.get_recon_process.forId(this.reconciler_id).execute();
              }
            );
          } else {
            this.list_reconciled_data
              .forId(this.reconciler_id)
              .config({
                params: {
                  ...this.state.filter_query,
                },
              })
              .execute();
          }
        }
      );
    }
  }
}

export default withDomains(ManualReconciled, "reconciliation", "allData");
